export default __webpack_public_path__ + "static/media/image.4205b6f1.svg";